var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import isEmpty from 'lodash.isempty';
import useDesign from '../../../hooks/useDesign';
import { NavigationItem } from '../../molecules/NavigationItem';
import { NavListItems, StyledNavigation } from './styled';
export var Navigation = function (_a) {
    var design = _a.design, pathname = _a.pathname, props = __rest(_a, ["design", "pathname"]);
    var _b = useDesign(design), schema = _b.schema, components = _b.components;
    var listItems = useDesign(components === null || components === void 0 ? void 0 : components.listItems);
    var list = isEmpty(listItems === null || listItems === void 0 ? void 0 : listItems.components) ? components : listItems === null || listItems === void 0 ? void 0 : listItems.components;
    return (_jsx(StyledNavigation, __assign({ schema: schema }, props, { children: _jsx(NavListItems, __assign({ schema: listItems === null || listItems === void 0 ? void 0 : listItems.schema }, { children: Object.keys(list)
                .sort()
                .map(function (key) { return (_jsx(NavigationItem, { design: list[key], pathname: pathname }, list[key])); }) })) })));
};
Navigation.displayName = 'Navigation';
Navigation.defaultProps = {
    pathname: '',
};
